"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const lucide_react_1 = require("lucide-react");
const useStore_1 = require("../../store/useStore");
const Reply_1 = require("../Reply/Reply");
const framer_motion_1 = require("framer-motion");
const RealtimeService_1 = require("../../services/RealtimeService");
const MusicFeatureService_1 = require("../../services/MusicFeatureService");
require("./MessageInput.css");
const EMOJIS = ['😊', '😂', '😍', '🔥', '🎉', '👍', '❤️', '🚀', '👀', '🤔', '😭', '😎', '👏', '✨', '💯', '💀', '💩', '🥳', '🎁', '🎈', '🌟', '💥', '🍕', '🍻'];
const MessageInput = ({ isDM }) => {
    const [message, setMessage] = (0, react_1.useState)('');
    const [attachments, setAttachments] = (0, react_1.useState)([]);
    const [showEmojiPicker, setShowEmojiPicker] = (0, react_1.useState)(false);
    const emojiPickerRef = (0, react_1.useRef)(null);
    const { selectedChannelId, currentUser, addTypingUser, removeTypingUser, typingUsers, typingUsernames, getChannelById, activeReply, sendMessage, selectedDMUserId, sendDM, getUserById, blockedUserIds, blockedByOtherIds, unblockUser } = (0, useStore_1.useStore)();
    const typingTimeoutRef = (0, react_1.useRef)(null);
    const lastTypingSentRef = (0, react_1.useRef)(0);
    const fileInputRef = (0, react_1.useRef)(null);
    const textInputRef = (0, react_1.useRef)(null);
    const emitTyping = (isTyping) => {
        if (!currentUser)
            return;
        const username = currentUser.displayName || currentUser.username || 'Kullanıcı';
        if (isDM && selectedDMUserId) {
            RealtimeService_1.realtimeService.sendTyping({
                dmUserId: selectedDMUserId,
                currentUserId: String(currentUser.id),
                username,
                isTyping,
            });
        }
        else if (selectedChannelId) {
            RealtimeService_1.realtimeService.sendTyping({
                channelId: selectedChannelId,
                currentUserId: String(currentUser.id),
                username,
                isTyping,
            });
        }
    };
    // Clean up typing on channel/DM switch
    (0, react_1.useEffect)(() => {
        return () => {
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }
            emitTyping(false);
            lastTypingSentRef.current = 0;
        };
    }, [selectedChannelId, selectedDMUserId]);
    // Compute active typing users for the current view
    const activeKey = isDM ? (selectedDMUserId ? `dm_${selectedDMUserId}` : '') : (selectedChannelId || '');
    const activeTypingUserIds = (activeKey && typingUsers[activeKey]) || [];
    const otherTypingIds = activeTypingUserIds.filter(id => String(id) !== String(currentUser?.id));
    const typingNames = otherTypingIds.map(id => {
        return typingUsernames[id] || getUserById(id)?.displayName || getUserById(id)?.username || 'Kullanıcı';
    });
    const typingText = typingNames.length === 1
        ? `${typingNames[0]} yazıyor...`
        : typingNames.length === 2
            ? `${typingNames[0]} ve ${typingNames[1]} yazıyor...`
            : `${typingNames[0]} ve ${typingNames.length - 1} kişi daha yazıyor...`;
    // Auto-focus on channel/DM switch and on initial mount
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => {
            textInputRef.current?.focus();
        }, 50);
        return () => clearTimeout(timer);
    }, [selectedChannelId, selectedDMUserId]);
    // Global typing auto-focus (Discord behavior: typing anywhere focuses the input)
    (0, react_1.useEffect)(() => {
        const handleGlobalKeyDown = (e) => {
            const target = e.target;
            if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)) {
                return;
            }
            if (e.key.length === 1 && !e.ctrlKey && !e.altKey && !e.metaKey) {
                textInputRef.current?.focus();
            }
        };
        window.addEventListener('keydown', handleGlobalKeyDown);
        return () => window.removeEventListener('keydown', handleGlobalKeyDown);
    }, []);
    const readFileAsDataUrl = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(new Error('Önizleme oluşturulamadı'));
        reader.readAsDataURL(file);
    });
    const handleFiles = async (files) => {
        const newAttachments = Array.from(files)
            .filter(file => file.type.startsWith('image/'))
            .map((file) => {
            const id = `a${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
            const previewUrl = URL.createObjectURL(file);
            return {
                id,
                file,
                previewUrl,
                type: file.type,
                status: 'uploading'
            };
        });
        if (newAttachments.length === 0)
            return;
        setAttachments((prev) => [...prev, ...newAttachments]);
        const { uploadFile } = useStore_1.useStore.getState();
        for (const draft of newAttachments) {
            try {
                const uploaded = await uploadFile(draft.file, 'chat');
                setAttachments(prev => prev.map(a => a.id === draft.id
                    ? { ...a, status: 'done', url: uploaded.url }
                    : a));
            }
            catch (err) {
                console.error('File upload failed:', err);
                setAttachments(prev => prev.map(a => a.id === draft.id
                    ? { ...a, status: 'error' }
                    : a));
            }
        }
    };
    const handlePaste = (e) => {
        const items = e.clipboardData.items;
        const imageFiles = [];
        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf('image') !== -1) {
                const file = items[i].getAsFile();
                if (file)
                    imageFiles.push(file);
            }
        }
        if (imageFiles.length > 0) {
            e.preventDefault();
            handleFiles(imageFiles);
        }
    };
    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            handleFiles(e.target.files);
            e.target.value = '';
        }
    };
    const handleRemoveAttachment = (id) => {
        setAttachments(prev => prev.filter(a => a.id !== id));
    };
    const [isSending, setIsSending] = (0, react_1.useState)(false);
    const handleSend = async () => {
        const trimmed = message.trim();
        const readyAttachments = attachments
            .filter(a => a.status === 'done' && a.url)
            .map(a => ({
            url: a.url,
            filename: a.file.name,
            type: a.type
        }));
        if (!trimmed && readyAttachments.length === 0)
            return;
        if (isSending)
            return;
        const isCurrentlyUploading = attachments.some(a => a.status === 'uploading');
        if (isCurrentlyUploading) {
            alert('Görseller yükleniyor, lütfen bekleyin...');
            return;
        }
        try {
            setIsSending(true);
            // Immediately stop typing indicator
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }
            emitTyping(false);
            lastTypingSentRef.current = 0;
            if (trimmed === '/match' || trimmed.startsWith('/match ')) {
                if (isDM && selectedDMUserId) {
                    const partner = getUserById(selectedDMUserId);
                    const partnerName = partner?.displayName || partner?.username || 'Kullanıcı';
                    const myName = currentUser?.displayName || currentUser?.username || 'Ben';
                    const matchResult = MusicFeatureService_1.musicFeatureService.calculateMatch(currentUser?.id || 0, myName, selectedDMUserId, partnerName);
                    const matchMsg = MusicFeatureService_1.musicFeatureService.formatMatchMessage(myName, partnerName, matchResult);
                    await sendDM(selectedDMUserId, matchMsg);
                }
                else {
                    alert('🎵 /match komutu sadece özel mesajlarda (DM) bir arkadaşınızla müzik zevki uyumunuzu ölçmek için kullanılır!');
                }
                setMessage('');
                setAttachments([]);
                setShowEmojiPicker(false);
                setIsSending(false);
                return;
            }
            if (isDM && selectedDMUserId) {
                await sendDM(selectedDMUserId, trimmed);
            }
            else if (selectedChannelId) {
                await sendMessage(trimmed, selectedChannelId, readyAttachments.length > 0 ? readyAttachments : undefined);
            }
            setMessage('');
            setAttachments([]);
            setShowEmojiPicker(false);
        }
        catch (error) {
            console.error('Failed to send message:', error);
        }
        finally {
            setIsSending(false);
            setTimeout(() => textInputRef.current?.focus(), 10);
        }
    };
    const handleInputChange = (e) => {
        setMessage(e.target.value);
        // Broadcast typing event throttled to every 2 seconds
        const now = Date.now();
        if (now - lastTypingSentRef.current > 2000) {
            lastTypingSentRef.current = now;
            emitTyping(true);
        }
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }
        typingTimeoutRef.current = setTimeout(() => {
            emitTyping(false);
            lastTypingSentRef.current = 0;
        }, 2500);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
            return;
        }
    };
    const handleAddEmoji = (emoji) => {
        setMessage(prev => prev + emoji);
    };
    const isAnyUploading = attachments.some(a => a.status === 'uploading');
    (0, react_1.useEffect)(() => {
        const handleOutsideClick = (e) => {
            if (emojiPickerRef.current && !emojiPickerRef.current.contains(e.target)) {
                setShowEmojiPicker(false);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }
        };
    }, []);
    const channel = selectedChannelId ? getChannelById(selectedChannelId) : undefined;
    const dmUser = isDM && selectedDMUserId ? getUserById(selectedDMUserId) : undefined;
    const isBlockedByMe = isDM && selectedDMUserId ? blockedUserIds.includes(selectedDMUserId) : false;
    const isBlockedByOther = isDM && selectedDMUserId ? blockedByOtherIds.includes(selectedDMUserId) : false;
    if (isDM && selectedDMUserId && (isBlockedByMe || isBlockedByOther)) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "message-input-area blocked-input-area", children: (0, jsx_runtime_1.jsx)("div", { className: "blocked-message-notice", children: isBlockedByMe ? ((0, jsx_runtime_1.jsxs)("div", { className: "blocked-notice-content", children: [(0, jsx_runtime_1.jsx)("span", { children: "Bu kullan\u0131c\u0131y\u0131 engellediniz. Mesaj g\u00F6nderemezsiniz." }), (0, jsx_runtime_1.jsx)("button", { className: "unblock-inline-btn", onClick: async () => {
                                try {
                                    await unblockUser(selectedDMUserId);
                                }
                                catch (e) {
                                    alert(e.message || 'Engel kaldırılamadı.');
                                }
                            }, children: "Engeli Kald\u0131r" })] })) : ((0, jsx_runtime_1.jsx)("div", { className: "blocked-notice-content", children: (0, jsx_runtime_1.jsx)("span", { children: "Bu kullan\u0131c\u0131 taraf\u0131ndan engellendiniz. Do\u011Frudan mesaj iletilemez." }) })) }) }));
    }
    const placeholder = isDM
        ? `@${dmUser?.username || 'Kullanıcı'} kullanıcısına mesaj gönder...`
        : channel ? `#${channel.name} kanalına mesaj gönder...` : 'Mesaj yaz...';
    const hasReply = !!activeReply;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "message-input-area", children: [(0, jsx_runtime_1.jsx)(Reply_1.Reply, {}), attachments.length > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "message-input-attachments", children: attachments.map((att) => ((0, jsx_runtime_1.jsx)("div", { className: `attachment-card ${att.status}`, children: (0, jsx_runtime_1.jsxs)("div", { className: "attachment-preview", children: [(0, jsx_runtime_1.jsx)("img", { src: att.previewUrl, alt: att.file.name }), att.status === 'uploading' && ((0, jsx_runtime_1.jsx)("div", { className: "attachment-loader", children: (0, jsx_runtime_1.jsx)("div", { className: "loader-spinner" }) })), att.status === 'error' && ((0, jsx_runtime_1.jsx)("div", { className: "attachment-error-overlay", title: "Y\u00FCkleme ba\u015Far\u0131s\u0131z", children: (0, jsx_runtime_1.jsx)(lucide_react_1.X, { size: 20, color: "#ef4444" }) })), (0, jsx_runtime_1.jsx)("button", { className: "attachment-remove-btn", onClick: () => handleRemoveAttachment(att.id), title: "Kald\u0131r", children: (0, jsx_runtime_1.jsx)(lucide_react_1.X, { size: 14 }) })] }) }, att.id))) })), (0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: otherTypingIds.length > 0 && ((0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { className: "typing-indicator-bar", initial: { opacity: 0, y: 3 }, animate: { opacity: 1, y: 0 }, exit: { opacity: 0, y: 3 }, transition: { duration: 0.15 }, children: [(0, jsx_runtime_1.jsxs)("div", { className: "typing-dots", children: [(0, jsx_runtime_1.jsx)("span", { className: "typing-dot" }), (0, jsx_runtime_1.jsx)("span", { className: "typing-dot" }), (0, jsx_runtime_1.jsx)("span", { className: "typing-dot" })] }), (0, jsx_runtime_1.jsx)("span", { className: "typing-text", children: typingText })] })) }), (0, jsx_runtime_1.jsxs)("div", { className: `message-input-control ${hasReply ? 'has-reply' : ''}`, children: [(0, jsx_runtime_1.jsx)("button", { className: "control-btn upload-btn", title: "Dosya Ekle", onClick: () => fileInputRef.current?.click(), children: (0, jsx_runtime_1.jsx)(lucide_react_1.Paperclip, { size: 18 }) }), (0, jsx_runtime_1.jsx)("input", { ref: fileInputRef, type: "file", accept: "image/*", multiple: true, style: { display: 'none' }, onChange: handleFileChange }), (0, jsx_runtime_1.jsx)("input", { ref: textInputRef, type: "text", className: "message-input-field", placeholder: isSending ? 'Mesaj gönderiliyor...' : placeholder, value: message, onChange: handleInputChange, onKeyDown: handleKeyDown, onPaste: handlePaste, disabled: isSending, autoFocus: true }), (0, jsx_runtime_1.jsxs)("div", { className: "input-actions-group", style: { position: 'relative' }, children: [(0, jsx_runtime_1.jsx)("button", { className: `control-btn ${showEmojiPicker ? 'active' : ''}`, title: "Emoji", disabled: isSending, onClick: () => setShowEmojiPicker(!showEmojiPicker), children: (0, jsx_runtime_1.jsx)(lucide_react_1.Smile, { size: 18 }) }), (0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: showEmojiPicker && ((0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { ref: emojiPickerRef, className: "input-emoji-picker-popover", initial: { opacity: 0, y: 10, scale: 0.95 }, animate: { opacity: 1, y: 0, scale: 1 }, exit: { opacity: 0, y: 10, scale: 0.95 }, transition: { duration: 0.15 }, children: [(0, jsx_runtime_1.jsx)("div", { className: "emoji-picker-title", children: "Emoji Se\u00E7" }), (0, jsx_runtime_1.jsx)("div", { className: "emoji-picker-grid", children: EMOJIS.map(emoji => ((0, jsx_runtime_1.jsx)("button", { className: "emoji-picker-btn", onClick: () => {
                                                    setMessage(prev => prev + emoji);
                                                    setShowEmojiPicker(false);
                                                }, children: emoji }, emoji))) })] })) }), (0, jsx_runtime_1.jsx)("button", { className: "control-btn", title: "Hediye", disabled: isSending, children: (0, jsx_runtime_1.jsx)(lucide_react_1.Gift, { size: 18 }) }), (0, jsx_runtime_1.jsx)("div", { className: "action-divider" }), (0, jsx_runtime_1.jsx)("button", { className: `send-btn ${(message.trim() || (attachments.length > 0 && !isAnyUploading)) ? 'active' : ''} ${isSending ? 'sending' : ''}`, onClick: handleSend, title: "G\u00F6nder", disabled: isSending || isAnyUploading || (!message.trim() && attachments.length === 0), children: (0, jsx_runtime_1.jsx)(lucide_react_1.Send, { size: 18 }) })] })] })] }));
};
exports.MessageInput = MessageInput;
